import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react'
import { createPortal } from 'react-dom'
import styles from 'components/Drawer/drawer.module.scss'
import debounce from 'lodash/debounce'

const scrollUpThreashold = 0

const Drawer = ({ open, children, className }) => {
  const drawerContainerElRef = useRef()
  const [overHeight, setOverheight] = useState(false)
  const [stickIt, setStickIt] = useState(false)
  const [startMargin, setStartMargin] = useState(0)
  const [drawerEl, setDrawerEl] = useState(
    document.getElementById('drawer-root'),
  )

  const handleScroll = useCallback(() => {
    if (drawerContainerElRef.current) {
      if (
        global.scrollY - scrollUpThreashold > startMargin &&
        !(
          drawerContainerElRef.current.offsetHeight >
          document.querySelector("[class*='with-drawer_content']").offsetHeight
        )
      ) {
        !stickIt && setStickIt(true)
      } else {
        setStickIt(false)
      }

      setOverheight(
        drawerContainerElRef.current.offsetHeight >
          document.querySelector("[class*='with-drawer_content']").offsetHeight,
      )
    }
  }, [drawerContainerElRef, startMargin, stickIt, setOverheight])

  useEffect(() => {
    global.addEventListener('scroll', debounce(handleScroll, 250))

    return () => {
      global.removeEventListener('scroll', debounce(handleScroll, 250))
    }
  }, [drawerContainerElRef.current, startMargin, stickIt])

  useEffect(() => {
    handleScroll()
  }, [])

  useEffect(() => {
    if (drawerContainerElRef.current) {
      const newStartMargin = Math.abs(
        drawerContainerElRef.current.getBoundingClientRect().top,
      )
      if (global.scrollY > newStartMargin - scrollUpThreashold) {
        !stickIt && setStickIt(true)
      } else {
        setStickIt(false)
      }
      setStartMargin(newStartMargin)
    }
  }, [drawerContainerElRef.current, global.innerHeight, global.innerWidth])

  useLayoutEffect(() => {
    setDrawerEl(document.getElementById('drawer-root'))
  }, [])

  return (
    drawerEl &&
    createPortal(
      <div
        ref={drawerContainerElRef}
        className={clsx(
          styles.drawer,
          {
            [styles['drawer_open']]: open,
            [styles['drawer_close']]: !open,
            [styles['drawer_sticky']]: stickIt,
            [styles['drawer_overheight']]: overHeight,
          },
          className,
        )}
      >
        {children}
      </div>,
      drawerEl,
    )
  )
}

Drawer.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
  className: PropTypes.string,
}

export default Drawer
